export enum SidebarType {
  Ranking = 'Ranking',
  OpenAnswer = 'OpenAnswer',
  Survey = 'Survey',
}
